/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_validators",
                type: "address[]",
            },
            {
                internalType: "uint8",
                name: "_threshold",
                type: "uint8",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "validators",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "threshold",
                type: "uint8",
            },
        ],
        name: "ValidatorsAndThresholdSet",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_validators",
                type: "address[]",
            },
            {
                internalType: "uint8",
                name: "_threshold",
                type: "uint8",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "moduleType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_validators",
                type: "address[]",
            },
            {
                internalType: "uint8",
                name: "_threshold",
                type: "uint8",
            },
        ],
        name: "setValidatorsAndThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
        ],
        name: "signatureCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "threshold",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "validators",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "validatorsAndThreshold",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class StorageMessageIdMultisigIsm__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_validators, _threshold, overrides) {
        return super.deploy(_validators, _threshold, overrides || {});
    }
    getDeployTransaction(_validators, _threshold, overrides) {
        return super.getDeployTransaction(_validators, _threshold, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=StorageMessageIdMultisigIsm__factory.js.map